import { useMemo } from 'react';
import type { Field, FileFieldValue, UploadedFileType } from '../../contexts';

export const useDisabledButton = (fields: Record<string, Field>) => {
  const fieldsArray = Object.values(fields);

  return useMemo(() => {
    const fileFields = fieldsArray.filter(({ type }: Field) => type === 'file');

    if (fileFields.length === 0) return false;

    return fileFields.some(({ value }) => {
      const fileValue = value as FileFieldValue;
      return fileValue?.some(({ uploaded }: UploadedFileType) => !uploaded);
    });
  }, [fieldsArray]);
};
